import _each from 'lodash/each';
import _uniq from 'lodash/uniq';
import _debounce from 'lodash/debounce';

import {registerHtmlHook} from "../utils/htmlHooks";

import $ from 'jquery';

function replace(el, html) {
    el.innerHTML = $(html)[0].innerHTML;
}

const getPricesInfo = function getPricesInfo(priceProducts) {
    const data = {
        products: [],
        quantities: {},
        components: {},
        options: {},
        renderHtml: true,
        checkGate: true,
    };

    const htmlMap = {};

    Array.from(priceProducts).forEach((el, index) => {
        data.products.push(el.dataset.productId)
        htmlMap[index] = el;
        if (!data.quantities[el.dataset.productId]) {
            data.quantities[el.dataset.productId] = {};
        }
        data.quantities[el.dataset.productId][index] = el.dataset.quantity ?? 1;
        data.components[el.dataset.productId] = {
            ...data.components[el.dataset.productId],
            [index]: el.dataset.component
        };
        // product options
        data.options[el.dataset.productId] = {};
        $('[name^="option-group"]', '.group-configurable-' + el.dataset.productId).each(function (index) {
            if (!$(this).is(':disabled') && ($(this).is('select') || $(this).is(':checked'))) {
                data.options[el.dataset.productId] = {
                    ...data.options[el.dataset.productId],
                    [index]: $(this).val()
                };
            }
        });

    })

    data.products = _uniq(data.products);

    $('.group-content').removeClass('option-missing');

    if (data.products.length > 0) {
        window.axios.post(window.config.urls.prices, data)
            .then(({data}) => {
                _each(data?.prices ?? [], (price) => {
                    // due to json response, this could be an array or an object (index starting at 0 or at > 0)
                    if (typeof price?.html === 'object') {
                        _each(Object.keys(price.html), (index) => {
                            replace(htmlMap[index], price.html[index]);
                        });
                    } else {
                        _each(price?.html ?? [], (html, index) => {
                            replace(htmlMap[index], html);
                        });
                    }
                    if (price.allowed) {
                        $('[data-listen-on-price-update][data-product-id="' + price.product_id + '"]').each(function () {
                            $(this).removeClass($(this).data('removeClass'));
                        });
                    }

                    if (price.option_prices) {
                        _each(price.option_prices ?? [], (option_price, index) => {
                            // delta price
                            $('.option-price-delta', '#product-option-' + index).html(option_price.delta.formatted);
                            $('.option-price-delta', '#product-option-mobile-' + index + ', #product-option-modal-mobile-' + index).html(option_price.delta.formatted);
                            // price
                            $('.option-price', '#product-option-group-' + option_price.group + ', #product-option-' + index).html(option_price.price.formatted);
                            $('.option-price', '#product-option-mobile-' + index + ', #product-option-modal-mobile-' + index).html(option_price.price.formatted);
                            $('.option-price', '#product-option-group-' + option_price.group + ', #product-option-' + index).toggleClass('d-none', option_price.included);
                            $('.option-price', '#product-option-mobile-' + index + ', #product-option-modal-mobile-' + index).toggleClass('d-none', option_price.included);
                            // vat hint
                            $('.option-price-delta', '#product-option-group-' + option_price.group + ', #product-option-' + index).next('.vat-hint').toggleClass('d-none', option_price.included);
                            $('.option-price-delta', '#product-option-mobile-' + index + ', #product-option-modal-mobile-' + index).next('.vat-hint').toggleClass('d-none', option_price.included);

                            let select = $('select', '#product-option-group-' + option_price.group + ', #group-edit-' + option_price.group);
                            if (select.length > 0) {
                                $.each(select, function () {
                                    let option = $('option[value="' + index + '"]', $(this)),
                                        data = option.text().trim().split(' | ');
                                    data[2] = option_price.delta.formatted;
                                    option.text(data.join(' | '));
                                });
                            }
                        });
                    }
                });

                $('[data-bs-toggle="popover"]').popover({
                        trigger: 'hover',
                        html: true
                    }
                )

                // trigger event
                $(document).trigger('price-call-finished', [data]);
            });
    }
};

const priceProducts = document.querySelectorAll('.price-async[data-product-id]');

if (priceProducts.length > 0) {
    getPricesInfo(priceProducts);
}

(function ($) {
    $(document.body).on('show.bs.modal', '.modal', function (e) {
        const priceProducts = e.target.querySelectorAll('.price-async[data-product-id]');
        if (priceProducts.length > 0) {
            getPricesInfo(priceProducts);
        }
    });

    $(document).on('change', '.detail-item-quantity-change', _debounce(function (e) {
        const element = $('div.detail-price-' + $(this).closest('div.quantity').data('productId')).first();
        if(element) {
            element[0].dataset.quantity = $(this).val();
            getPricesInfo([element[0]]);
        }
    }, 200));
})(jQuery);

registerHtmlHook((container) => getPricesInfo($(container).find('.price-async[data-product-id]')));

export default getPricesInfo;
